/* eslint-disable react/forbid-elements */
import { H3, Paragraph, YStack, Text } from '@bounty/creators-design-system'
import { ReactNode } from 'react'
import FeaturesBudget from '../../../assets/features-budget.png'
import FeaturesCompliance from '../../../assets/features-compliance.png'
import FeaturesContent from '../../../assets/features-content.png'
import FeaturesCreatorExperience from '../../../assets/features-creator-experience.png'
import FeaturesStorefront from '../../../assets/features-storefront.png'
import FeaturesUsageRights from '../../../assets/features-usage-rights.png'

const FeatureWrapper = ({
  children,
  isOdd = false,
  isBig = false,
  isMiddle = false,
}: {
  children: ReactNode
  isOdd?: boolean
  isBig?: boolean
  isMiddle?: boolean
}) => {
  return (
    <YStack
      width="100%"
      mb="$6"
      $gtXs={{
        width: '50%',
        mb: '$6',
        pr: isOdd ? '$3' : '0',
        pl: isOdd ? '0' : '$3',
      }}
      $gtMd={{
        width: isBig ? '46%' : '27%',
        pr: isMiddle ? '$6' : '0',
        pl: isMiddle ? '$6' : '0',
      }}
    >
      <YStack
        flex={1}
        borderWidth={1}
        borderColor="$blackAlpha.100"
        borderRadius={'$8'}
        pt="$8"
        backgroundColor={'$neutral.100'}
        overflow="hidden"
        space="$8"
        justifyContent="space-between"
      >
        {children}
      </YStack>
    </YStack>
  )
}

export const Features = () => {
  return (
    <YStack
      width="100%"
      maxWidth={1300}
      flexWrap="wrap"
      px="$4"
      py="$3"
      alignSelf="center"
      $gtXs={{ flexDirection: 'row' }}
    >
      <FeatureWrapper isOdd isBig>
        <YStack px="$5" alignItems="center">
          <H3
            textAlign="center"
            color="rgba(92, 225, 230, 1)"
            size="$xl"
            mb="$4"
          >
            Control your own CPMs. Set your prices.
          </H3>
          <Paragraph textAlign="center" color="$neutral.700">
            Control your own CPMs. Set your prices. With Bounty, you call the
            shots. Bounty{' '}
            <Text fontWeight={'$semibold'}>pays creators for views</Text>{' '}
            generated in the{' '}
            <Text fontWeight={'$semibold'}>first 48 hours</Text>. They can
            withdraw their funds{' '}
            <Text fontWeight={'$semibold'}>after post approval</Text> and 15
            days live.
          </Paragraph>
        </YStack>
        <YStack px="$16" pb="$6">
          <img
            loading="lazy"
            src={FeaturesBudget}
            alt="Bounty budget feature"
          />
        </YStack>
      </FeatureWrapper>
      <FeatureWrapper isMiddle>
        <YStack px="$5" alignItems="center">
          <H3
            textAlign="center"
            color="rgba(92, 225, 230, 1)"
            size="$xl"
            mb="$4"
          >
            Never lose your content.
          </H3>
          <Paragraph textAlign="center" color="$neutral.700">
            Performance is tracked with{' '}
            <Text fontWeight={'$semibold'}>first party data</Text> and available
            for every post.
          </Paragraph>
        </YStack>
        <YStack px="$16" pb="$6">
          <img
            loading="lazy"
            src={FeaturesContent}
            alt="Bounty content feature"
          />
        </YStack>
      </FeatureWrapper>
      <FeatureWrapper isOdd>
        <YStack px="$5" alignItems="center">
          <H3
            textAlign="center"
            color="rgba(92, 225, 230, 1)"
            size="$xl"
            mb="$4"
          >
            Get instant usage rights.
          </H3>
          <Paragraph textAlign="center" color="$neutral.700">
            Get instant usage rights for all content created through Bounty. Use
            the content anytime, anywhere, forever.{' '}
          </Paragraph>
        </YStack>
        <YStack px="$16">
          <img
            loading="lazy"
            src={FeaturesUsageRights}
            alt="Bounty usage rights feature"
          />
        </YStack>
      </FeatureWrapper>
      <FeatureWrapper>
        <YStack px="$5" alignItems="center">
          <H3
            textAlign="center"
            color="rgba(92, 225, 230, 1)"
            size="$xl"
            mb="$4"
          >
            Fully managed creator experience
          </H3>
          <Paragraph textAlign="center" color="$neutral.700">
            Define your <Text fontWeight={'$semibold'}>rules</Text>. Customize{' '}
            <Text fontWeight={'$semibold'}>creative briefs</Text> at a store or
            product level.
          </Paragraph>
        </YStack>
        <YStack px="$16">
          <img
            loading="lazy"
            src={FeaturesCreatorExperience}
            alt="Bounty creator experience"
          />
        </YStack>
      </FeatureWrapper>
      <FeatureWrapper isMiddle isBig isOdd>
        <YStack px="$5" alignItems="center">
          <H3
            textAlign="center"
            color="rgba(92, 225, 230, 1)"
            size="$xl"
            mb="$4"
          >
            Customize your listing in our brand directory.
          </H3>
          <Paragraph textAlign="center" color="$neutral.700">
            {/* TODO: Make dynamic */}
            Exposure to <Text fontWeight="$semibold">30,000+</Text> shoppers who
            love creating content.{' '}
            <Text fontWeight={'$semibold'}>Promote your offers</Text> and{' '}
            <Text fontWeight={'$semibold'}>get featured</Text>.
          </Paragraph>
        </YStack>
        <YStack>
          <img
            loading="lazy"
            src={FeaturesStorefront}
            alt="Bounty store directory feature"
          />
        </YStack>
      </FeatureWrapper>
      <FeatureWrapper>
        <YStack px="$5" alignItems="center">
          <H3
            textAlign="center"
            color="rgba(92, 225, 230, 1)"
            size="$xl"
            mb="$4"
          >
            Forget about the boring stuff
          </H3>
          <Paragraph textAlign="center" color="$neutral.700">
            FTC compliance, content approvals and taxes, we handle it all.
          </Paragraph>
        </YStack>
        <YStack px="$16">
          <img
            loading="lazy"
            src={FeaturesCompliance}
            alt="Bounty compliance feature"
          />
        </YStack>
      </FeatureWrapper>
    </YStack>
  )
}
